import { ViewModel,View } from "binder"
import { BindingPrototypeParser } from "src/binder/parser/prototype/bindingPrototype";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DataModelClass } from "src/formBuilder/datamodel/structure";
import { GetCurrentDataModelClassMessage } from "../../../templateEditor-viewModel";
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { VmFunctionEditorView } from "./vmFunctionEditor-view"

export class VmFunctionEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        let dataModelClass : DataModelClass = this.handleMessage(new GetCurrentDataModelClassMessage());
        this.suggestions = dataModelClass.GetMethods().map(x=>x.name);

    }
    GetDefaultView(): View <ViewModel> {
        return new VmFunctionEditorView();
    }
    public getTypeId(): string {
        return "VM-8A5F0545-7688-40BC-A537-C9CC7CFF2602"
    }


    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    public set suggestions(v: string[]) { this._suggestions = v; } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];
    
    setValue(v: string) {
        let isValid = false;
        try{
            if(stringIsNullOrEmpty(v)==false && BindingPrototypeParser.IsBindingExpression(v)){
                var parsedValue = BindingPrototypeParser.Parse(v);
                this.value = parsedValue.path;
                isValid = true;
            }
        }
        catch{

        }

        if(isValid==false){
            this.value = v;
        }
    }
    getValue(): string {
        if(stringIsNullOrEmpty(this.value)==false){
            return `{Binding ${this.value.trim()}}`;
        }
        return '';
    }
    requestConfirm() {
    }

}
